export const AGREEMENT_STATUS = {
  WAITING: 'waiting',
  FULFILLED: 'fulfilled',
  NOT_FULFILLED: 'not-fulfilled',
};
